import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

// export default new Vue({
//   router,
//   store,
//   el: '#app',
//   template: '<App/>',
//   components: { App },
// });

new Vue({
    router,
    store,
    // @ts-ignore
    vuetify,
    render: h => h(App)
}).$mount('#app')
